<template>
  <div class="order-index" ref="container">
    <div class="header acea-row">
      <router-link class="item" :to="'/user/promoter_order_list/0'">
        <div class="num">{{ census.unpaid_count }}</div>
        <div>待付款</div>
      </router-link>
      <router-link class="item" :to="'/user/promoter_order_list/1'">
        <div class="num">{{ census.unshipped_count }}</div>
        <div>待发货</div>
      </router-link>
      <router-link class="item" :to="'/user/promoter_order_list/2'">
        <div class="num">{{ census.received_count }}</div>
        <div>待收货</div>
      </router-link>
      <router-link class="item" :to="'/user/promoter_order_list/3'">
        <div class="num">{{ census.evaluated_count }}</div>
        <div>待评价</div>
      </router-link>
      <router-link class="item" :to="'/user/promoter_order_list/-3'">
        <div class="num">{{ census.refund_count }}</div>
        <div>退款</div>
      </router-link>
    </div>
    <div class="wrapper">
      <div class="title">
        <span class="iconfont icon-shujutongji"></span>数据统计
      </div>
      <div class="list acea-row">
        <router-link class="item" :to="'/user/promoter_statistics/price/today'">
          <div class="num">{{ census.todaySale }}</div>
          <div>本周销售量</div>
        </router-link>
        <router-link
          class="item"
          :to="'/user/promoter_statistics/price/yesterday'"
        >
          <div class="num">{{ census.proSale }}</div>
          <div>上周销量</div>
        </router-link>
        <router-link class="item" :to="'/user/promoter_statistics/price/month'">
          <div class="num">{{ census.monthSale }}</div>
          <div>本月销售量</div>
        </router-link>
        <router-link class="item" :to="'/user/promoter_statistics/order/today'">
          <div class="num">{{ census.todayCount }}</div>
          <div>本周订单数</div>
        </router-link>
        <router-link
          class="item"
          :to="'/user/promoter_statistics/order/yesterday'"
        >
          <div class="num">{{ census.proCount }}</div>
          <div>上周订单数</div>
        </router-link>
        <router-link class="item" :to="'/user/promoter_statistics/order/month'">
          <div class="num">{{ census.monthCount }}</div>
          <div>本月订单数</div>
        </router-link>
      </div>
    </div>
    <div class="public-wrapper">
      <div class="title">
        <span class="iconfont icon-xiangxishuju"></span>详细数据
      </div>
      <div class="nav acea-row row-between-wrapper">
        <div class="data">日期</div>
        <div class="browse">订单数</div>
        <div class="turnover">销售量</div>
      </div>
      <div class="conter">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="outer-item acea-row row-between-wrapper">
            <div class="data">
              <div
                :class="isViewMore.indexOf(index) !== -1 ? 'plus more' : 'plus'"
                @click="showMore(index)"
                v-if="item.spread && item.spread.length > 0"
              >
                +
              </div>
              <div class="blank" v-else></div>
              {{ item.time }}
            </div>
            <div class="browse">{{ item.count }}</div>
            <div class="turnover">{{ item.sale }}</div>
          </div>
          <div
            :class="
              isViewMore.indexOf(index) !== -1
                ? 'inner-item'
                : 'inner-item inner-hide'
            "
          >
            <div
              class="inner-data"
              v-for="(item2, index) in item.spread"
              :key="index"
            >
              <div class="inner-info">
                <div class="avatar">
                  <img :src="item2.avatar" class="avatar-img" />
                </div>
                <div class="content-info">
                  <div class="nickname">昵称：{{ item2.nickname }}</div>
                  <div class="uid">编号：{{ item2.uid }}</div>
                </div>
              </div>
              <div class="num">{{ item2.count }}</div>
              <div class="sale">{{ item2.sale }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getOrderStatistics, getOrderStateDetail } from "../../../../api/user";
import Loading from "@components/moblie/Loading";
export default {
  name: "OrderIndex",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      census: {},
      list: [],
      where: {
        page: 1,
        limit: 15
      },
      loaded: false,
      loading: false,
      isViewMore: []
    };
  },
  mounted: function() {
    this.getIndex();
    this.getList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getList();
    });
  },
  methods: {
    getIndex: function() {
      var that = this;
      getOrderStatistics().then(
        res => {
          that.census = res.data;
          console.log("census");
          console.log(that.census);
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    getList: function() {
      var that = this;
      if (that.loading || that.loaded) return;
      that.loading = true;
      getOrderStateDetail(that.where).then(
        res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.limit;
          that.list.push.apply(that.list, res.data);
          that.where.page = that.where.page + 1;
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    showMore(index) {
      console.log("zhuan");
      if (this.isViewMore.indexOf(index) == -1) {
        this.isViewMore.push(index);
      } else {
        let i = this.isViewMore.indexOf(index);
        this.isViewMore.splice(i, 1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.plus {
  display: inline-block;
  font-size: 0.3rem;
  border: 0.01rem solid #000;
  border-radius: 100rem;
  text-align: center;
  height: 0.3rem;
  width: 0.3rem;
  box-sizing: border-box;
  line-height: 0.3rem;
  transition: all 0.5s;
}
.more {
  transform: rotate(45deg);
}
.item2 {
  display: flex;
  align-items: center;
  padding: 0.2rem;
  border-bottom: 0.01 solid #000;
}
.avatar-img {
  height: 0.8rem;
  width: 0.8rem;
}

.inner-item {
  transition: all 0.2s;
  overflow: hidden;
}

.inner-hide {
  height: 0;
}

.inner-data {
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  justify-content: space-between;
  .num {
    flex-grow: 1;
  }
  .sale {
    flex: 1;
    text-align: right;
  }
}
.inner-data:not(:last-child) {
  border-bottom: 0.01rem solid gray;
}

.avatar {
  border-radius: 100rem;
  box-shadow: 0 0 0.05rem grey;
  overflow: hidden;
}

.inner-info {
  display: flex;
  align-items: center;
  // flex-grow: 1;
}
.content-info {
  margin-left: 0.2rem;
  margin-right: 0.35rem;
  width: 2.55rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.blank {
  display: inline-block;
  height: 0.3rem;
  width: 0.3rem;
  box-sizing: border-box;
}
</style>
